/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react'

import { Button, Modal } from '@octane/spark'
import { getLenderDisclosures } from 'api/lender'
import DisclosureType from 'state/enums/DisclosureType'
import camelCase from 'utils/camelCase'

import { ModalButton, Content } from './DisclosureModal.styled'

type Props = {
    showModal: boolean
    toggleModal: React.Dispatch<React.SetStateAction<boolean>>
    modalTitle: string
    disclosureName: DisclosureType
    lenderId: number
    applicationId?: number
} & typeof defaultProps

const defaultProps = {
    applicationId: 0,
}

export default function DisclosureModal({
    showModal,
    toggleModal,
    modalTitle,
    disclosureName,
    lenderId,
    applicationId,
}: Props) {
    const [disclosureText, setDisclosureText] = useState<string>()

    useEffect(() => {
        const loadLenderDisclosures = async () => {
            if (lenderId) {
                const result = await getLenderDisclosures(
                    lenderId,
                    applicationId,
                )

                const disclosure = result.data.find(
                    (item) => item.name === disclosureName,
                )

                if (disclosure) {
                    setDisclosureText(disclosure.text)
                }
            }
        }

        loadLenderDisclosures().catch(() =>
            setDisclosureText(
                // eslint-disable-next-line max-len
                `An error occured while fetching the disclosure text, please close and reopen the modal to try again.`,
            ),
        )
    }, [applicationId, lenderId, disclosureName])

    const testId = `modalContent-${camelCase(modalTitle)}`

    return (
        <Modal
            title={modalTitle}
            isOpen={showModal}
            onClose={() => toggleModal(false)}
            scroll="body"
            size="large"
        >
            <Modal.Body>
                <Content data-testid={testId}>
                    <p data-testid={disclosureName}>{disclosureText}</p>
                </Content>
            </Modal.Body>
            <Modal.Footer>
                <ModalButton>
                    <Button
                        type="button"
                        variant="primaryOutlined"
                        onClick={() => toggleModal(false)}
                    >
                        Close
                    </Button>
                </ModalButton>
            </Modal.Footer>
        </Modal>
    )
}

DisclosureModal.defaultProps = defaultProps
